import { loggerFactory } from '@vestigas/logger';

import { environment } from '~/constants/environment';

export const log = loggerFactory({ environment });

export const LOG = {
  // https://develop.sentry.dev/sdk/event-payloads/breadcrumbs/#breadcrumb-types
  // types: navigation, user, info
  // categories: form, modal, click, state change, props change, filter, selection
  // level: fatal, critical, error, warning, log, info, debug
  BREADCRUMB: {
    FILTER_CHANGE: {
      CATEGORY: 'filter',
      DEFAULT_MESSAGE: 'Change filter value',
      KEY: 'filter-change',
      TYPE: 'user',
    },
    FORM_CHANGE: {
      CATEGORY: 'form',
      DEFAULT_MESSAGE: 'Change form value',
      KEY: 'form-change',
      TYPE: 'user',
    },
    FORM_CLOSE: {
      CATEGORY: 'form',
      DEFAULT_MESSAGE: 'Close form',
      KEY: 'form-close',
      TYPE: 'navigation',
    },
    FORM_OPEN: {
      CATEGORY: 'form',
      DEFAULT_MESSAGE: 'Open form',
      KEY: 'form-open',
      TYPE: 'navigation',
    },
    FORM_SUBMIT: {
      CATEGORY: 'form',
      DEFAULT_MESSAGE: 'Submit form',
      KEY: 'form-submit',
      TYPE: 'user',
    },
    HTTP_NOT_200: {
      CATEGORY: 'xhr',
      DEFAULT_MESSAGE: 'Response status is not 200',
      KEY: 'http-not-200',
      TYPE: 'http',
    },
    INIT_MODEL: {
      CATEGORY: 'model',
      DEFAULT_MESSAGE: 'Initialize model',
      KEY: 'init-model',
      TYPE: 'info',
    },
    MODAL_OPEN: {
      CATEGORY: 'modal',
      DEFAULT_MESSAGE: 'Open modal',
      KEY: 'modal-open',
      TYPE: 'navigation',
    },
    REDUX_CHANGE: {
      CATEGORY: 'redux',
      DEFAULT_MESSAGE: 'Change redux state',
      KEY: 'redux-change',
      TYPE: 'info',
    },
    SELECTION_CHANGE: {
      CATEGORY: 'selection',
      DEFAULT_MESSAGE: 'Change selection value',
      KEY: 'selection-change',
      TYPE: 'user',
    },
    USER_ACTION: {
      CATEGORY: 'action',
      DEFAULT_MESSAGE: undefined,
      KEY: 'user-action',
      TYPE: 'user',
    },
  },

  FEATURE: {
    ACCORDION: 'Accordion',
    ADD_ITEM_MODAL: 'Add item modal',
    ARCHIVE_MODE: 'Archive mode',
    ARTICLE_MASTER: 'Article master',
    AUTHENTICATION: 'Authentication',
    BASIC_TABLE: 'Basic table',
    BAYWA_SCREEN: 'BayWa screen',
    COMPANY: 'Company',
    COMPLEX_PAGINATED_MULTI_PICKER: 'Complex paginated multi picker',
    CONCRETE_DIARY: 'Concrete diary',
    COST_CENTER: 'Cost center',
    CREATE_DELIVERY_NOTE: 'Create delivery note',
    CURRENT_SITE_AND_COST_CENTER: 'Current site and cost center',
    CUSTOM_FIELD: 'Custom field',
    DASHBOARD: 'Dashboard',
    DATA_PROTECTION: 'Data protection',
    DATA_SUBSCRIPTION: 'Data subscription',
    DELIVERY_CHANGES: 'Delivery changes',
    DELIVERY_LIST: 'Delivery list',
    DELIVERY_NOTE: 'Delivery note',
    DELIVERY_OVERVIEW: 'Delivery overview',
    EXCEL_DOWNLOAD: 'Excel download',
    FILTER_GROUPS: 'Filter groups',
    FORM: 'Form',
    HOME: 'Home',
    IDS: 'IDS',
    IMAGE_UPLOAD: 'Image upload',
    INVOICE: 'Invoice',
    INVOICE_CHECK: 'Invoice check',
    INVOICE_LIST: 'Invoice list',
    KANBAN_SUPPLIER_OVERVIEW: 'Kanban Supplier Overview',
    MENU: 'Menu',
    NAVIGATION: 'Navigation',
    NOTIFICATIONS: 'Notifications',
    ORGANISATIONAL_GROUP: 'Organisational group',
    OTHER_FEATURE: 'Other feature',
    PDF_DOWNLOAD: 'PDF download',
    PDF_SETTINGS: 'PDF settings',
    PDF_TEMPLATE: 'PDF template',
    PDF_VIEWER: 'PDF viewer',
    PERMISSION_GRANT_DIALOG: 'Permission grant dialog',
    PERMISSIONS: 'Permissions',
    PRODUCT: 'Product',
    PRODUCT_PRICE: 'Product price',
    PROFILE: 'Profile',
    REPORT: 'Report',
    SETTINGS_TABLE: 'Settings table',
    SHARE_DELIVERY_NOTE: 'Share delivery note',
    SIGNATURE_FIELD: 'Signature field',
    SITE: 'Site',
    SITE_MAPPING: 'Site mapping',
    SUBSCRIPTION: 'Subscription',
    SUPPLIER_CONTACT_PAGE: 'Supplier contact page',
    SUPPLIER_OVERVIEW: 'Supplier overview',
    USER: 'User',
    USER_GROUP: 'User group',
    VEHICLE: 'Vehicle',
    WIZARD: 'Wizard',
  },
  TYPE: {
    ERROR: 'Error',
    FAILED_VALIDATION: 'Failed Validation',
  },
};
